var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#32B168","cx":"10","cy":"10","r":"10"}}),_c('path',{attrs:{"d":"M8.414 15.356L4 11.136l1.32-1.369 2.908 2.78 6.283-7.827L16 5.906z","fill":"#FFF"}})])}
var staticRenderFns = []

export { render, staticRenderFns }